// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b60d5064","806":"c0797ada"}[chunkId] + ".chunk.js";
};